// Client/ClientsWrapper.tsx
import React, {useContext, useEffect, useState} from 'react';
import {AuthContext, AuthContextType} from "Auth/AuthContext";
import {axios} from "Auth/axiosConfig";

import {useErrorProcessing} from "Core/components/ErrorProvider";
import {useNavigate} from "react-router-dom";
import pprint from '../../Utils/pprint';
import ClientItem from "Client/ClientItem";

interface Client {
    id: number;

    [key: string]: any; // Описание других свойств клиента
}

interface ClientsWrapperProps {
    className?: string;
}

const ClientsWrapper: React.FC<ClientsWrapperProps> = ({className}) => {
    const {isAuthenticated, user} = useContext(AuthContext) as AuthContextType;
    const {byResponse, notAuthentication} = useErrorProcessing();
    const [psychologistClients, setPsychologistClients] = useState<Client[]>([]);

    const navigate = useNavigate();

    useEffect(() => {
        if (!isAuthenticated) {
            notAuthentication();
            return;
        }
        axios.get('/api/v1/psychologist/clients/')
            .then((response) => {
                pprint('Psychologist Clients');
                pprint(response.data);
                setPsychologistClients(response.data);
            })
            .catch(error => byResponse(error));
    }, [user, isAuthenticated]);

    return (
        <div className={`${className} fr flex-wrap gap-3 py-3 overflow-y-auto no-scrollbar`}>
            {psychologistClients.map((client) => (
                <ClientItem
                    onClick={() => navigate(`/clients/${client.id}`)}
                    key={client.id}
                    client={client}
                />
            ))}
        </div>
    );
};

export default ClientsWrapper;
